import { useState } from "react";

import { Box, Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import Close from '@mui/icons-material/Close';
import Printicon from "@mui/icons-material/Print";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import dayjs from "dayjs";
import { grey } from "@mui/material/colors";

const InvoiceReport = ({ apiData = {}, callback, orderItems = {}, totals = {} }) => {

  const dataToUse = apiData[0] || {};
  // --- SAFE DATA EXTRACTION ---
  const header = dataToUse.invoice_detail?.[0] || {};
  //const dispatchPlanItem = dataToUse.dispatch_plan?.[0] || {}; 
  const itemsData = dataToUse.invoice_items;
  const defaultReportData = {
    Header: {
      InvoiceNo: header.invoiceno || "",
      InvoiceDate: header.invoicedate || "",
    },
    Buyer: {
      Name: apiData[0].invoice_detail[0].billtoname || "",
      Address: [
        header.billto_addrline1 || "",
        header.billto_addrline2 || "",
        header.billto_addrcity || "",
      ].filter(Boolean).join(", "),
      GSTIN: header.billto_gstno || "",
      State: header.billto_addrstate || "",
      Code: header.billto_gststatecode || "",
      Country: header.billto_addrcountry || "",
      Pincode: header.billto_addrpincode || "",
    },
    Consignee: {
      Name: header.shiptoname || "",
      Address: [
        header.shipto_addrline1 || "",
        header.shipto_addrline2 || "",
        header.shipto_addrcity || "",

      ].filter(Boolean).join(", "),
      GSTIN: header.shipto_gstno || "",
      State: header.shipto_addrstate || "",
      Code: header.shipto_gststatecode || "",
      Country: header.shipto_addrcountry || "",
      Pincode: header.shipto_addrpincode || "",
    },
    Company: {
      Name: apiData[0].invoice_detail[0].companyname || "",
      Address: [
        header.company_addrline1 || "",
        header.company_addrline2 || "",
        header.company_addrline3 || "",
        header.company_addrline3 || "",
        "PIN:" + header.shipto_addrpincode || "",
      ].filter(Boolean).join(", "),
      StateCountry: [
        header.company_addrstate || "",
        header.company_addrcountry || "",
      ].filter(Boolean).join(", "),
      GSTIN: header.company_gstno || "",
      MailID: header.company_addremailid || "",
      Phone: header.company_addrtelno || "",
      State: header.shipto_gststatecode || "",
      Code: header.shipto_gststatecode || "",
    },

    Items: Array.isArray(itemsData)
      ? itemsData.map((item) => ({
        quality: item.name || "",
        gsm: item.gsm || "",
        size: item.itemsize || "",
        hsn: item.hsncode || "",
        orderNo: item.invoiceorderid || "",
        qty: item.confirmed_qty || "",
        uom: item.unitofmeasurecode || "",
        totalWeight: item.confirmed_qty || "",
        unitPrice: item.unitprice || "",
        totalValue: item.itemtotalamount || "",
        unit: item.unit || "",
        reelbundlecount: item.reelbundlecount || "",
      }))
      : [],
    TotalReels: 0,
    TotalWeight: 0,
    TotalValue: 0,
    Summary: {
      AssessableValue: header.taxable_amount || 0,
      TaxAmount: header.tax_amount || 0,
      Freight: 0,
      Insurance: 0,
      Discount: 0,
      NetAmount: header.net_amount || 0,
      AmountInWords: header.netamount_inwords || "",
      RoundOff: 0,
    },
    Transport: {
      Name: header.transporterdetails?.match(/Transporter Name\s*:\s*(.*)/)?.[1] || "",
      VehicleNo: header.transporterdetails?.match(/Vehicle No\.\s*:\s*(.*)/)?.[1] || "",
      ShipmentMode: header.transporterdetails?.match(/Shipment Mode\s*:\s*(.*)/)?.[1] || "",
      LRNo: header.transporterdetails?.match(/LR No\.\s*:\s*(.*)/)?.[1] || "",
      TermsOfPayment: header.transporterdetails?.match(/Terms of Payment\s*:\s*(.*)/)?.[1] || "",
      DueDate: header?.transporterdetails?.match(/Due Date\s*:\s*(.*)/)?.[1] || "",
    },
    Bank: {
      Name: header.paymentbankdetails?.match(/Name\s*:\s*(.*)/)?.[1] || "",
      AccountNo: header.paymentbankdetails?.match(/A\/C No\s*:\s*(.*)/)?.[1] || "",
      IFSC: header.paymentbankdetails?.match(/IFSC\s*:\s*(.*)/)?.[1] || "",
      BankName: header.paymentbankdetails?.match(/Bank\s*:\s*(.*)/)?.[1] || "",
      Branch: header.paymentbankdetails?.match(/Branch\s*:\s*(.*)/)?.[1] || "",
    },
    IRN: "",
    AckNo: "",
    EWayBillNumber: "",
    EWayBillDate: "",
    PlaceOfDelivery: "",
    FSC: {
      Code: "",
      Claim: "",
    },
  };


  const [reportData] = useState(defaultReportData);
  const handleClose = () => {
    if (callback) callback(false);
  };
  const handlePrintAll = () => {
    const copyTypes = ["ORIGINAL", "DUPLICATE", "TRIPLICATE"];
    const allContent = copyTypes
      .map((copy) => {
        const element = document.getElementById(`invoiceReport-${copy}`);
        return element ? element.innerHTML : "";
      })
      .join('<div style="page-break-after: always;"></div>');

    const newWindow = window.open("", "_blank", "width=900,height=700");

    if (!newWindow) {
      alert("Please allow pop-ups for this website to print the report.");
      return;
    }

    newWindow.document.write(`
      <html>
        <head>
          <title>Invoice Report</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 9px; margin: 0; padding: 0; }
            table { border-collapse: collapse; width: 100%; table-layout: fixed; }
            th, td { border: 1px solid #000; padding: 5px; text-align: left; }
            .invoice-page {
              width: 210mm;
              min-height: 297mm;
              margin: 0 auto;
              padding: 10mm 15mm;
              box-sizing: border-box;
            }
          </style>
        </head>
        <body>
          ${allContent}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.focus();
    newWindow.print();
    newWindow.close();
  };


  const numberToWords = (num) => {
    if (num == null || isNaN(num)) return "";

    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
      "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy",
      "Eighty", "Ninety"
    ];

    const convertBelowThousand = (n) => {
      if (n === 0) return "";
      if (n < 20) return ones[n];
      if (n < 100)
        return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
      return (
        ones[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + convertBelowThousand(n % 100) : "")
      );
    };

    const convertToIndianWords = (n) => {
      const crore = Math.floor(n / 10000000);
      const lakh = Math.floor((n % 10000000) / 100000);
      const thousand = Math.floor((n % 100000) / 1000);
      const hundred = n % 1000;

      let str = "";
      if (crore) str += convertBelowThousand(crore) + " Crore ";
      if (lakh) str += convertBelowThousand(lakh) + " Lakh ";
      if (thousand) str += convertBelowThousand(thousand) + " Thousand ";
      if (hundred) str += convertBelowThousand(hundred);
      return str.trim();
    };

    const [rupees, paise] = num.toFixed(2).split(".");
    let words = convertToIndianWords(parseInt(rupees)) + " Rupees";
    if (parseInt(paise) > 0)
      words += " and " + convertToIndianWords(parseInt(paise)) + " Paise";
    return words + " Only";
  };


  const renderInvoiceCopy = (copyType) => {
    const { Summary, Header, Buyer, Company, Consignee, Items, Transport, Bank, EWayBillNumber, EWayBillDate, PlaceOfDelivery, FSC, TotalReels, TotalWeight, TotalValue, IRN, AckNo } = reportData;

    return (
      <div
        className="invoice-page"
        style={{
          width: "210mm",
          minHeight: "297mm",
          margin: "10px auto",
          padding: "5mm 5mm",
          boxSizing: "border-box",
          border: "1px solid #000000ff",
          background: "#fff",      // ✅ White background
          pageBreakAfter: "always",
          fontFamily: "Arial, sans-serif",
          fontSize: "12px",        // ✅ Larger font size
          color: "#000",
        }}
      >

        {/* Header Section */}
        <div style={{  border: "1px solid #000",padding:"5px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "5px" }}>
            <div style={{ textAlign: "left" }}>
              <img src="/path/to/your/fsc-logo.png" alt="FSC Logo" style={{ width: "80px", marginBottom: "5px" }} />
              <p style={{ margin: 0, fontSize: "10px", whiteSpace: "nowrap" }}>
                www.fsc.org<br />
                FSC® C210691<br />
                The mark of responsible forestry
              </p>
            </div>
            <div style={{ textAlign: "center", flexGrow: 1 }}>
              <h3 style={{ margin: "0", whiteSpace: "nowrap" }}>{Company.Name}</h3>
              <div style={{ whiteSpace: "nowrap" }}>{Company.Address}</div>
              <div style={{ whiteSpace: "nowrap" }}>{Company.StateCountry}</div>
              {/* <div style={{ whiteSpace: "nowrap" }}>Mail: {Company.MailID} | TEL: {Company.Phone}</div> */}
              {(Company?.MailID || Company?.Phone) && (<div style={{ whiteSpace: "nowrap" }}>    {Company?.MailID && <>Mail: {Company.MailID}</>}    {Company?.MailID && Company?.Phone && " | "}
                {Company?.Phone && <>TEL: {Company.Phone}</>}
              </div>
              )}

              <div style={{ whiteSpace: "nowrap" }}>GSTIN: {Company.GSTIN}</div>
            </div>
            <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
              <h4 style={{ margin: "0" }}>{copyType}</h4>
            </div>
          </div>
        </div>
        <div style={{ textAlign: "center", border: "1px solid #000", borderTop:"none" , backgroundColor: "#e0e0e0"  }}>
          <h2 style={{ margin: "0" }}>Tax Invoice</h2>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0px", border: "1px solid #000", borderBottom: "none",borderTop:"none" }}>
          <div style={{ width: "35%", borderRight: "1px solid #000", padding: "5px" }}>
            <h4>Buyers Name & Address</h4>
            <strong> <p style={{ margin: 0, textTransform: 'uppercase' }}>{Buyer.Name}</p></strong>
            <p style={{ margin: 0, textTransform: 'uppercase' }}>{Buyer.Address}</p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}>{Buyer.State}</p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}>{Buyer.Country} - {Buyer.Pincode}</p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}><strong>GSTIN :</strong> {Buyer.GSTIN}</p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}>
              <strong>State :</strong> {Buyer.State}
            </p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}><strong>Code :</strong> {Buyer.Code}</p>
          </div>
          <div style={{ width: "35%", borderRight: "1px solid #000", padding: "5px" }}>
            <h4>Consignee Name & Address</h4>
            <strong><p style={{ margin: 0, textTransform: 'uppercase' }}>{Consignee.Name}</p></strong>
            <p style={{ margin: 0, textTransform: 'uppercase' }}>{Consignee.Address}</p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}>{Consignee.State}</p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}>{Consignee.Country} - {Consignee.Pincode}</p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}><strong>GSTIN :</strong> {Consignee.GSTIN}</p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}>
              <strong> State :</strong> {Consignee.State}
            </p>
            <p style={{ margin: 0, textTransform: 'uppercase' }}><strong>Code :</strong> {Consignee.Code}</p>
          </div>

          <div
            style={{
              width: "30%",
              padding: "5px",
              // borderRight: "1px solid #000",
              display: "table",
              fontSize: "12px", // reduced font size
            }}
          >
            {[
              { label: "Invoice No", value: Header.InvoiceNo },
              { label: "Invoice Date", value: Header?.InvoiceDate ? dayjs(Header.InvoiceDate).format("DD-MMM-YYYY") : "" },
              { label: "E-Way Bill Number", value: EWayBillNumber },
              { label: "E-Way Bill Date", value: EWayBillDate },
              { label: "Place of Delivery", value: PlaceOfDelivery },
            ].map((item, idx) => (
              <div key={idx} style={{ display: "table-row" }}>
                <div
                  style={{
                    display: "table-cell",
                    fontWeight: "bold",
                    paddingRight: "2px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.label}
                </div>
                <div style={{ display: "table-cell", textTransform: 'uppercase' }}> : {item.value || "-"}</div>
              </div>
            ))}

            <div style={{ textAlign: "center", marginTop: "10px", border: "1px solid #000", padding: "5px" }}>
              <img src="/path/to/your/fsc-logo.png" alt="FSC Logo" style={{ width: "60px", marginBottom: "5px" }} />
              <p style={{ margin: "0", fontSize: "8px" }}>
                www.fsc.org<br />
                FSC® C210691<br />
                The mark of<br />
                responsible forestry
              </p>
            </div>
          </div>


          {/* <div style={{ width: "30%", padding: "5px" }}>
            <p style={{ margin: "0" }}>
              <strong>Invoice No</strong>: {Header.InvoiceNo}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Invoice Date</strong>: {Header?.InvoiceDate ? dayjs(Header.InvoiceDate).format("DD-MMM-YYYY") : ""}
            </p>
            <p style={{ margin: "0" }}>
              <strong>E-Way Bill Number</strong>: {EWayBillNumber}
            </p>
            <p style={{ margin: "0" }}>
              <strong>E-Way Bill Date</strong>: {EWayBillDate}
            </p>
            <p style={{ margin: "0" }}>
              <strong>Place of Delivery</strong>: {PlaceOfDelivery}
            </p>
            <div style={{ textAlign: "center", marginTop: "10px", border: "1px solid #000", padding: "5px" }}>
              <img src="/path/to/your/fsc-logo.png" alt="FSC Logo" style={{ width: "60px", marginBottom: "5px" }} />
              <p style={{ margin: "0", fontSize: "8px" }}>
                www.fsc.org<br />
                FSC® C210691<br />
                The mark of<br />
                responsible forestry
              </p>
            </div>
          </div> */}
        </div>

        {/* <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "5px", fontSize: "9px", tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "5%" }}>S.No</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Quality</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "10%" }}>HSN</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Order No</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "5%" }}>GSM</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "6%" }}>Unit</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Size</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Total Reels/ Bundles</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "10%" }}>Total Weight</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "6%" }}>UoM</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "10%" }}>Unit Price</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Total Value</th>
            </tr>
          </thead>
          <tbody>

            {Items.map((row, idx) => (
              <tr key={idx}>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{idx + 1}</td>
                <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}>{row.quality}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{row.hsn}</td>
                <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}>{row.orderNo}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{row.gsm}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{ }</td>
                <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}>{row.size}</td>
                <td style={{ border: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}>{ }</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", whiteSpace: "nowrap" }}>{row.totalWeight}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap" }}>{row.uom}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", whiteSpace: "nowrap" }}>{row.unitPrice?.toFixed(2)}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", whiteSpace: "nowrap" }}>{row.totalValue?.toFixed(2)}</td>
              </tr>
            ))}


            <tr>
              <td colSpan="7" style={{ border: "1px solid #000", padding: "5px", textAlign: "right", fontWeight: "bold" }}>TOTAL</td>
              <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", fontWeight: "bold" }}>{TotalReels}</td>
              <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", fontWeight: "bold" }}> {rows.reduce((sum, row) => sum + (Number(row.totalWeight) || 0), 0).toFixed(2)}</td>
              <td style={{ border: "1px solid #000", borderRight: "none", padding: "5px", whiteSpace: "nowrap" }}></td>
              <td style={{ borderBottom: "1px solid #000", padding: "5px", whiteSpace: "nowrap" }}></td>

              <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", fontWeight: "bold" }}>{TotalValue}</td>
            </tr>
          </tbody>
        </table> */}

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            // marginBottom: "5px",
            fontSize: "9px",
            tableLayout: "fixed",
          }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "5%" }}>S.No</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Quality</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "10%" }}>HSN</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Order No</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "5%" }}>GSM</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "6%" }}>Unit</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "12%" }}>Size</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", width: "12%" }}>Total Reels / Bundles</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", width: "10%" }}>Total Weight</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "nowrap", width: "6%" }}>UoM</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", width: "10%" }}>Unit Price</th>
              <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", width: "12%" }}>Total Value (INR)</th>
            </tr>
          </thead>

          <tbody>
            {Items.map((row, idx) => (
              <tr key={idx}>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>{idx + 1}</td>
                <td style={{ border: "1px solid #000", padding: "5px" }}>{row.quality}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>{row.hsn}</td>
                <td style={{ border: "1px solid #000", padding: "5px" }}>{row.orderNo}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>{row.gsm}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>{row.unit || ""}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>{row.size}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>{row.reelbundlecount || 0}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>{row.totalWeight?.toFixed(2)}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>{row.uom}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>{row.unitPrice?.toFixed(2)}</td>
                <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>{row.totalValue}</td>
              </tr>
            ))}

            {/* ✅ Total Row */}
            <tr>
              <td
                colSpan="7"
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                TOTAL
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {Items.reduce((sum, row) => sum + (Number(row.totalReels) || 0), 0)}
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {Items.reduce((sum, row) => sum + (Number(row.totalWeight) || 0), 0).toFixed(2)}
              </td>
              <td style={{ border: "1px solid #000", padding: "5px" }}></td>
              <td style={{ border: "1px solid #000", padding: "5px" }}></td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: "5px",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {Items.reduce((sum, row) => sum + (Number(row.totalValue) || 0), 0).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>


        {/* New Sections */}
        <div style={{ display: "flex", justifyContent: "space-between", border: "1px solid #000", borderTop: "none" }}>

          <div
            style={{
              width: "70%",
              padding: "5px",
              borderRight: "1px solid #000",
              display: "table",
              fontSize: "10px", // reduced font size
            }}
          >
            {[
              { label: "Transporter Name", value: Transport.Name },
              { label: "Shipment Mode", value: Transport.ShipmentMode },
              { label: "Vehicle No", value: Transport.VehicleNo },
              { label: "LR No", value: Transport.LRNo },
              { label: "Policy No", value: Transport.PolicyNo },
              { label: "Terms of Payment", value: Transport.TermsOfPayment },
              { label: "Due Date", value: Transport.DueDate },
            ].map((item, idx) => (
              <div key={idx} style={{ display: "table-row" }}>
                <div
                  style={{
                    display: "table-cell",
                    fontWeight: "bold",
                    paddingRight: "2px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.label}
                </div>
                <div style={{ display: "table-cell" }}> : {item.value || "-"}</div>
              </div>
            ))}
          </div>



          <div style={{ width: "30%", padding: "5px" }}>
            {/* <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Discount Value</span><span>{totals.totalDiscount}</span>
            </p> */}
            {/* <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Freight</span><span>{totals.freightAmount?.toFixed(2)}</span>
            </p> */}
            {/* <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Insurance @ {totals.insurancePercentage} %</span><span>{totals.insuranceAmount?.toFixed(2)}</span>
            </p> */}

            <p style={{ margin: "0", display: "flex", justifyContent: "space-between", }}            >
              <span>Discount Value</span>
              <span>{totals?.totalDiscount ? totals.totalDiscount : "-"}</span>
            </p>

            {totals?.freightAmount > 0 && (<p style={{ margin: "0", display: "flex", justifyContent: "space-between", }}  >
              <span>Freight </span>
              <span>{totals.freightAmount.toFixed(2)}</span>
            </p>
            )}

            {totals?.insuranceAmount > 0 && (<p style={{ margin: "0", display: "flex", justifyContent: "space-between", }}  >
              <span>Insurance @ {totals.insurancePercentage} %</span>
              <span>{totals.insuranceAmount.toFixed(2)}</span>
            </p>
            )}
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Assessable Value</span><span>{totals.totalTaxableAmount?.toFixed(2)}</span>
            </p>
            {/* <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>IGST @{totals.igstRate} %</span><span>{totals.igstAmount?.toFixed(2)}</span>
            </p> */}
            {/* <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>CGST @{totals.cgstRate} %</span><span>{totals.cgstAmount?.toFixed(2)}</span>
            </p> */}
            {/* <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>SGST @{totals.sgstRate} %</span><span>{totals.sgstAmount?.toFixed(2)}</span>
            </p> */}

            {totals?.igstAmount > 0 && (<p style={{ margin: "0", display: "flex", justifyContent: "space-between", }}  >
              <span>IGST @ {totals.igstRate} %</span>
              <span>{totals.igstAmount.toFixed(2)}</span>
            </p>
            )}

            {totals?.cgstAmount > 0 && (<p style={{ margin: "0", display: "flex", justifyContent: "space-between", }}  >
              <span>CGST @ {totals.cgstRate} %</span>
              <span>{totals.cgstAmount.toFixed(2)}</span>
            </p>
            )}

            {totals?.sgstAmount > 0 && (<p style={{ margin: "0", display: "flex", justifyContent: "space-between", }}  >
              <span>SGST @ {totals.sgstRate} %</span>
              <span>{totals.sgstAmount.toFixed(2)}</span>
            </p>
            )}

            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span>Round Off</span><span>{totals.roundOff?.toFixed(2)}</span>
            </p>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between", borderTop: "1px solid #000", paddingTop: "5px" }}>
              <strong>Invoice Value</strong><strong>{totals.netAmountWithRounding?.toFixed(2)}</strong>
            </p>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", border: "1px solid #000", borderTop: 'none' }}>
          <div style={{ width: "70%", padding: "5px", borderRight: "1px solid #000" }}>
            <p style={{ margin: "0" }}>
              <strong>Amount In Words:</strong>{" "}{totals?.netAmountWithRounding != null ? numberToWords(totals.netAmountWithRounding) : "-"}
            </p>
          </div>
          <div style={{ width: "30%", padding: "5px" }}>
            <p style={{ margin: "0", display: "flex", justifyContent: "space-between" }}>
              <span><strong>Net Amount Receivable</strong></span><span>{totals.netAmountWithRounding?.toFixed(2)}</span>
            </p>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", border: "1px solid #000", borderTop: 'none' }}>


          <div
            style={{
              width: "70%",
              padding: "5px",
              borderRight: "none",
              display: "table",
              fontSize: "12px", // reduced font size
            }}
          >
            <p style={{ margin: "0" }}>
              <strong>Bank Details</strong>
            </p>
            {[
              { label: "Name", value: Bank.Name },
              { label: "A/C No", value: Bank.AccountNo },
              { label: "IFSC", value: Bank.IFSC },
              { label: "Bank", value: Bank.BankName },
              { label: "Branch", value: Bank.Branch },
            ].map((item, idx) => (
              <div key={idx} style={{ display: "table-row" }}>
                <div
                  style={{
                    display: "table-cell",
                    fontWeight: "bold",
                    paddingRight: "2px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.label}
                </div>
                <div style={{ display: "table-cell" }}> : {item.value || "-"}</div>
              </div>
            ))}
          </div>


          <div style={{ width: "30%", padding: "5px" }}>
            <p style={{ margin: "0" }}>
              <strong>FSC-COC Code</strong>: {FSC.Code}
            </p>
            <p style={{ margin: "0" }}>
              <strong>FSC CLAIM</strong>: {FSC.Claim}
            </p>
            <p style={{ margin: "5px 0 0", fontSize: "8px" }}>
              Note: Only the products that are identified as such on this document are FSC certified.
            </p>
          </div>
        </div>

        {/* Footer section added based on the provided image */}
        <div style={{ border: "1px solid #000", padding: "5px", display: "flex", alignItems: "flex-start",borderTop:"none" }}>
          <div style={{ width: "100px", flexShrink: 0, marginRight: "10px" }}>
            {/* Placeholder for the QR code image */}


            [Image of a QR Code]

          </div>
          <div style={{ flexGrow: 1 }}>
            <p style={{ margin: "0" }}><strong>Ack No</strong>: {AckNo}</p>
            <p style={{ margin: "0" }}><strong>IRN</strong>: {IRN}</p>
            <div style={{ marginTop: "10px", textAlign: "right" }}>
              <p style={{ margin: "0" }}>For {Company.Name}</p>
              <p style={{ margin: "20px 0 0" }}>Authorized Signatories</p>
            </div>
          </div>
        </div>
        <div style={{ border: "1px solid #000", borderTop: "none", padding: "5px", textAlign: "left", fontSize: "8px" }}>
          <p style={{ margin: "0" }}>Certified that the particulars given above are true and correct and the amount indicated represents the price actually charged and that there is no flow of additional consideration directly or indirectly from the buyer.</p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center" padding={0}>
        {/* Left-aligned: Edit Employee */}
        <Grid item>
          <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
            Print Invoice Report
          </Typography>
        </Grid>

        {/* Right-aligned: Buttons */}
        <Grid item>
          <Grid container alignItems="center">
            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            {/* Save */}
            <Grid item ml={1} mr={1}>
              <Tooltip title="Add new orders">
                <IconButton
                  onClick={() => handlePrintAll()}
                  sx={{ display: 'flex', alignItems: 'center' }}
                // type="submit"
                >
                  <Printicon style={{ fontSize: "18px", color: "#009688" }} />
                  <Typography variant="body2" sx={{ ml: 1 }}> Print</Typography>
                </IconButton>
              </Tooltip>
            </Grid>

            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

            <IconButton onClick={() => { handleClose() }}>
              <Close style={{ fontSize: "14px", color: "#2196F3" }} />
            </IconButton>

            <Divider orientation="vertical" flexItem />

          </Grid>
        </Grid>
      </Grid>

      <Divider />
      <Box>

        <ResponsiveBox
          customMaxHeight={{
            xs: '60vh',  // Custom value for extra small devices
            sm: '65vh',  // Custom value for small devices
            md: '70vh',  // Custom value for medium devices
            lg: '84vh',  // Custom value for large devices
            xl: '89.6vh',  // Custom value for extra large devices
          }}>

          {["ORIGINAL", "DUPLICATE", "TRIPLICATE"].map((copy) => (
            <div key={copy} id={`invoiceReport-${copy}`}>
              {renderInvoiceCopy(copy)}
            </div>
          ))}

        </ResponsiveBox>
      </Box>
    </>
  );
};

export default InvoiceReport;